import { backend_api_v2 } from '/src/utils/apiv2'
import base from "./base"
// import bus from '/src/utils/event_bus'
// import router from '/src/router'
import { defineStore } from 'pinia'

export const useReportsStore = defineStore('reports', {
    state: () => ({
        reports: [],
        // How many components on screen show `reports`, the project the list
        // was loaded for, and the project selected now. See loadReportsWhenUsed.
        reports_users: 0,
        reports_for: null,
        reports_wanted: null,
        // Catalog of document types: [{ document_type, label, bucket }]
        document_types_catalog: [],
    }),
    getters: {
        // Map document_type -> bucket ('production_machine' | 'production_doc' | 'management')
        bucketByType() {
            const map = {}
            for (const dt of this.document_types_catalog) map[dt.document_type] = dt.bucket
            return map
        },
        // bucket of a document_type (fallback: production_machine, matches backend)
        bucketOf() {
            return (document_type) => this.bucketByType[document_type] || "production_machine"
        },
        // true if a document_type belongs to the Production views
        isProductionType() {
            return (document_type) => this.bucketOf(document_type) !== "management"
        },
        // true if a document_type belongs to the Management view
        isManagementType() {
            return (document_type) => this.bucketOf(document_type) === "management"
        },
    },
    actions: {
        // Reports
        setReports: base.actions.setter("reports"),
        replaceReport: base.actions.updater("reports"),
        createReport: base.actions.creator("reports"),
        updateReport: base.actions.updater("reports"),
        removeReport: base.actions.remover("reports"),

        // Reports
        loadReports: base.actions.loader_pr("reports/reports/", "Reports"),
        postReport: base.actions.poster("reports/reports/", "Report"),
        putReport: base.actions.putter("reports/reports/", "Report"),
        deleteReport: base.actions.deleter("reports/reports/", "Report"),
        refreshReport: base.actions.refresher("reports/reports/", "Report"),

        // The list is loaded only while something on screen uses it. It used to
        // load on every project change, and the production tablets, which never
        // show reports, change project all day: 244 of 546 report list requests
        // in a morning came from them, each serializing every version of every
        // report of the project.
        loadReportsWhenUsed(project_uuid) {
            this.reports_wanted = project_uuid
            if (this.reports_users > 0) return this.loadReportsFor(project_uuid)
            // Nobody shows them: drop the previous project's list now and load
            // the selected one on the next use.
            this.setReports([])
            this.reports_for = null
            return Promise.resolve()
        },
        loadReportsFor(project_uuid) {
            this.reports_for = project_uuid
            return this.loadReports(project_uuid)
        },
        // Called by the components that show reports, on mount and unmount.
        useReports() {
            this.reports_users += 1
            if (this.reports_wanted != null && this.reports_for !== this.reports_wanted)
                return this.loadReportsFor(this.reports_wanted)
            return Promise.resolve()
        },
        releaseReports() {
            this.reports_users = Math.max(0, this.reports_users - 1)
        },

        loadDocumentTypes() {
            // Cache-once: the catalog is static per deploy.
            if (this.document_types_catalog.length) return Promise.resolve()
            return backend_api_v2.get("reports/document_types/")
                .then(({ data }) => { this.document_types_catalog = data })
                .catch(() => { /* views fall back to showing all types */ })
        },

        putReportNoJob(payload) {
            const url = "reports/reports/";
            const finalUrl = `${url}${payload?.uuid}/?no_job=true`;

            return backend_api_v2.put(finalUrl, payload)
                .then(({ data }) => {
                    this.updateReport(data)
                    return { data }
                });
        }
    },
})
